module.exports = __webpack_public_path__ + "img/letsStart.b4eac91f.svg";